import * as swcHelpers from '@swc/helpers';
import { useQuery } from '@grandvisionhq/graphql';
import GET_SHOPPING_LIST_BY_ID from '../operations/queries/get-shopping-list-by-id-product.js';
import GET_SHOPPING_LIST_BY_ID_VARIANT from '../operations/queries/get-shopping-list-by-id-variant.js';
import { combineRefetchFunctions } from '../utils/combine-refetch-functions.js';
import { combineWishlistData } from '../utils/combine-wishlist-data.js';
import { mapShoppingListToWishlistItems } from '../utils/map-shopping-list-to-wishlist-items.js';

const useGetAnonWishlist = ({ locale , isAuthLoading , isUserLoggedIn , localWishlist , clearWishlist  })=>{
    var ref4, ref1;
    const anonWishlistQueryOptions = {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        skip: isAuthLoading || isUserLoggedIn || !localWishlist,
        variables: {
            shoppinglistId: localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id
        },
        onCompleted: (data)=>{
            var ref;
            if (((ref = data.shoppinglistById.failure) === null || ref === void 0 ? void 0 : ref.__typename) === 'ShoppinglistNotFoundFailure') {
                clearWishlist();
            }
        }
    };
    const { data: anonWishlistProductData , loading: anonWishlistProductLoading , error: anonWishlistProductError , refetch: anonWishlistProductRefetch ,  } = useQuery(GET_SHOPPING_LIST_BY_ID, swcHelpers.objectSpread({}, anonWishlistQueryOptions));
    const { data: anonWishlistVariantData , loading: anonWishlistVariantLoading , error: anonWishlistVariantError , refetch: anonWishlistVariantRefetch ,  } = useQuery(GET_SHOPPING_LIST_BY_ID_VARIANT, swcHelpers.objectSpread({}, anonWishlistQueryOptions));
    const combinedAnonRefetch = combineRefetchFunctions(anonWishlistProductRefetch, anonWishlistVariantRefetch);
    const isLoading = anonWishlistProductLoading || anonWishlistVariantLoading;
    const combinedAnonData = combineWishlistData(anonWishlistVariantData === null || anonWishlistVariantData === void 0 ? void 0 : (ref4 = anonWishlistVariantData.shoppinglistById) === null || ref4 === void 0 ? void 0 : ref4.shoppinglist, anonWishlistProductData === null || anonWishlistProductData === void 0 ? void 0 : (ref1 = anonWishlistProductData.shoppinglistById) === null || ref1 === void 0 ? void 0 : ref1.shoppinglist);
    var ref2;
    const mappedAnonData = {
        items: mapShoppingListToWishlistItems(locale, combinedAnonData),
        id: (ref2 = localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id) !== null && ref2 !== void 0 ? ref2 : ''
    };
    var ref3;
    const error = (ref3 = anonWishlistProductError || anonWishlistVariantError) !== null && ref3 !== void 0 ? ref3 : null;
    return {
        data: !error ? mappedAnonData : null,
        loading: isLoading,
        error,
        refetch: combinedAnonRefetch
    };
};

export { useGetAnonWishlist };
//# sourceMappingURL=use-get-anon-wishlist.js.map
